import { createSlice } from "@reduxjs/toolkit";
import { Account } from "../Model/Account";
import {
  fetchAccounts,
  addAccount,
  editAccount,
  removeAccount,
  removeAccountMany,
  resetPassword,
} from "./actions";

interface AccountState {
  list: Account[];
  loading: boolean;
  error?: string;
}

const initialState: AccountState = {
  list: [],
  loading: false,
};

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccounts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAccounts.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading = false;
      })
      .addCase(fetchAccounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addAccount.fulfilled, (state, action) => {
        state.list.push(action.payload);
      })
      .addCase(editAccount.fulfilled, (state, action) => {
        state.list = state.list.map((acc) =>
          acc.id === action.payload.id ? action.payload : acc
        );
      })
      .addCase(removeAccount.fulfilled, (state, action) => {
        state.list = state.list.filter((acc) => acc.id !== action.meta.arg);
      })
      .addCase(removeAccountMany.fulfilled, (state, action) => {
        const idSet = new Set(action.meta.arg);
        state.list = state.list.filter((acc) => !idSet.has(acc.id));
      })
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(resetPassword.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default accountSlice.reducer;
